<template>
    <v-card-actions>
        <p v-if="$isDesktop() && editorFlightLegMode === 'rotation'" class="mb-0 ml-3 font-weight-bold">
            Rotation
        </p>
        <p v-if="$isDesktop() && editorFlightLegMode === 'single'" class="mb-0 ml-3 font-weight-bold">
            Single
        </p>

        <div v-if="$isDesktop()" class="mx-5" style="width:1px; height:100%; background: #D7D8DA;" />

        <!-- input_FlightDateType: 0 = Dates, 1 = Weekly -->
        <p v-if="$isDesktop() && editorMode === 'create'" class="font-weight-bold mb-0">
            {{ counter }} Series Dates
        </p>

        <p v-if="$isDesktop() && editorMode === 'update' || editorMode === 'combine'" class="font-weight-bold mb-0" style="width: 200px;">
            Selected Flights: {{ counter }}
        </p>

        <div v-if="$isDesktop()" class="mx-5" style="width:1px; height:100%; background: #D7D8DA;" />

        <v-spacer v-if="$isDesktop()" />
        <div style="display:flex;justify-content:end;width:100%;">
            <v-btn style="width:120px" depressed elevation="1" outlined color="#ab3b7a" @click="onClick_CloseSheet">
                Close
            </v-btn>
            <v-btn
                style="width:120px;margin-left:8px"
                depressed elevation="1"
                color="primary"
                @click="onClick_Save">
                Save
            </v-btn>
        </div>
    </v-card-actions>
</template>

<script>
    export default {
        name: 'ActionBar',

        /* >>> *************************************************************** / /* Props */
        props: {

            editorMode: String, // 'create', 'update'
            counter: Number, // number of active eventRecords
            editorFlightLegMode: String // 'single', 'rotation'
        }, // eo props{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {};

        }, // eo data{}
        /* <<< ****************************************************************/



        /* >>> ***************************************************************** / /* Methods */
        methods: {

            /*******************************************************************
            * Listeners: Common
            *******************************************************************/
            /*******************************************************************
            * onClick_CloseSheet
            *
            * Desc:
            * Note:
            *
            */
            onClick_CloseSheet: function() {

                const me = this;


                me.$toc('>>> views/shared/components/core/Bottomsheet/ActionBar.vue >>> onClick_Save');
                me.$emit('close');

            }, // eo function onClick_CloseSheet()


            /*******************************************************************
            * onClick_Save
            *
            * Desc:
            * Note:
            *
            */
            onClick_Save: function() {

                const me = this;


                me.$toc('>>> views/shared/components/core/Bottomsheet/ActionBar.vue >>> onClick_Save');
                me.$emit('save');

            } // eo function onClick_Save()

        } // eo methods

    };
</script>

<style scoped>
    .sdr-disabled {
        background-color: rgba(0, 0, 0, 0.12) !important;
        color: rgba(0, 0, 0, 0.26) !important;
    }
</style>
